<script>
import * as authApi from '@/api/auth';
import NoticeBar from './NoticeBar.vue';
export default {
    name: 'Register',
    components: { NoticeBar },
    // 声明自定义事件
    emits: ['switch-to-login'],
    data() {
        return {
            username: '',
            idCard: '', // 身份证号字段
            password: '',
            confirmPassword: '',
            email: '',
            phone: '',
            agree: false,
            title: '',
            currentWeekday: '',
            currentDate: '',
            noticeVisible: false,
            noticeMessage: '',
            noticeType: 'info',
            noticeActions: [],
            submitting: false
        }
    },
    mounted() {
        // 页面加载时获取一次时间
        this.updateDateTime();
    },
    methods: {
        updateDateTime() {
            const now = new Date();

            // 获取星期几
            const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            this.currentWeekday = weekdays[now.getDay()];

            // 获取年月日，格式化为YYYY-MM-DD
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            this.currentDate = `${year}-${month}-${day}`;
        },
        // 触发自定义事件，通知父组件(App.vue)切换到登录页面
        goToLogin(event) {
            // 阻止<a>标签的默认行为
            event.preventDefault();
            this.$emit('switch-to-login');
        },

        openAgreement() {
            try { sessionStorage.setItem('last_page', '#register') } catch (e) {}
            window.location.hash = 'user-agreement'
        },

        // 处理注册表单提交
        async handleRegister() {
            // 防止重复提交
            if (this.submitting) return
            
            // 是否同意协议
            if (!this.agree) {
                this.showNotice('请勾选并同意用户协议后再注册', 'warning');
                return;
            }
            
            // 用户名验证
            if (!this.username || this.username.trim() === '') {
                this.showNotice('请输入用户名', 'warning');
                return;
            }
            if (this.username.trim().length < 3) {
                this.showNotice('用户名长度至少3个字符', 'warning');
                return;
            }
            if (this.username.trim().length > 50) {
                this.showNotice('用户名长度不能超过50个字符', 'warning');
                return;
            }
            
            // 密码验证
            if (!this.password || this.password.length < 6) {
                this.showNotice('密码长度至少6个字符', 'warning');
                return;
            }
            if (this.password.length > 128) {
                this.showNotice('密码长度不能超过128个字符', 'warning');
                return;
            }
            // 表单验证逻辑
            if (this.password !== this.confirmPassword) {
                this.showNotice('两次输入的密码不一致，请重新输入', 'warning');
                return;
            }

            // 身份证号简单验证（18位）
            if (!/^\d{17}[\dXx]$/.test(this.idCard)) {
                this.showNotice('请输入有效的18位身份证号码', 'warning');
                return;
            }

            // 手机号简单验证
            if (!/^1[3-9]\d{9}$/.test(this.phone)) {
                this.showNotice('请输入有效的手机号码', 'warning');
                return;
            }

            this.submitting = true
            try {
                const payload = {
                    username: this.username.trim(),
                    password: this.password,
                    confirm_password: this.confirmPassword,
                    email: this.email.trim(),
                    id_card: this.idCard.trim(),
                    phone: this.phone.trim(),
                };
                // 调用后端注册接口
                await authApi.register(payload);
                this.showNotice('注册成功！已自动登录，跳转到首页', 'success');
                // 注册成功时后端返回令牌和用户信息，已在 api 层保存
                // 直接跳转登录页或首页，这里跳首页体验更好
                setTimeout(() => { window.location.hash = 'home'; }, 1500);
            } catch (err) {
                // 简化处理后端错误提示
                const data = err?.response?.data || {};
                if (typeof data === 'string') {
                    this.showNotice(data, 'error');
                    return;
                }
                // 收集常见字段错误并合并展示
                const msgs = [];
                const pick = (k) => {
                    const v = data?.[k];
                    if (Array.isArray(v) && v.length) msgs.push(`${k}: ${v[0]}`);
                    else if (typeof v === 'string') msgs.push(`${k}: ${v}`);
                };
                pick('non_field_errors');
                pick('username');
                pick('email');
                pick('id_card');
                pick('phone');
                pick('password');
                pick('confirm_password');
                this.showNotice(msgs.length ? msgs.join('\n') : '注册失败，请检查输入信息', 'error');
            } finally {
                this.submitting = false
            }
        },
        showNotice(message, type = 'info', actions = [], autoHideMs = 2500) {
            this.noticeMessage = message
            this.noticeType = type
            this.noticeActions = actions
            this.noticeVisible = true
            if (autoHideMs > 0) setTimeout(() => { this.noticeVisible = false }, autoHideMs)
        }
    }
}
</script>
<template>
    <NoticeBar :visible="noticeVisible" :message="noticeMessage" :type="noticeType" :actions="noticeActions" @close="noticeVisible=false" />
    <div class="header">
        <p>欢迎来到{{ title }}考试报名系统</p>
        <div class="right_title">
            <p>{{ currentWeekday }}</p>
            <p>{{ currentDate }}</p>
        </div>
    </div>
    <div class="main_content">
        <div class="register_container">
            <h1>注册</h1>
            <form @submit.prevent="handleRegister">
                <div class="form-group">
                    <label for="username">用户名:</label>
                    <input type="text" id="username" v-model="username" placeholder="请输入用户名" required>
                </div>
                <div class="form-group">
                    <label for="idCard">身份证号:</label>
                    <input type="text" id="idCard" v-model="idCard" placeholder="请输入身份证号" required maxlength="18" oninput="value=value.replace(/[^0-9Xx]/g,'')">
                </div>
                <div class="form-group">
                    <label for="password">密码:</label>
                    <input type="password" id="password" v-model="password" placeholder="请输入密码" required>
                </div>
                <div class="form-group">
                    <label for="confirmPassword">确认密码:</label>
                    <input type="password" id="confirmPassword" v-model="confirmPassword" placeholder="请再次输入密码"
                        required>
                </div>
                <div class="form-group">
                    <label for="email">邮箱:</label>
                    <input type="email" id="email" v-model="email" placeholder="请输入邮箱" required>
                </div>
                <div class="form-group">
                    <label for="phone">手机号:</label>
                    <input type="tel" id="phone" v-model="phone" placeholder="请输入手机号" required maxlength="11" oninput="value=value.replace(/[^\d]/g,'')">
                </div>
                <div class="agreement">
                    <input type="checkbox" id="agree" v-model="agree">
                    <label for="agree">我已阅读并同意<a href="#user-agreement" @click.prevent="openAgreement">用户协议</a></label>
                </div>
                <button type="submit" class="register-btn">注册</button>
                <div class="login-link">
                    <p>已有账号？<a href="#" @click="goToLogin">返回登录</a></p>
                </div>
            </form>
        </div>
    </div>
</template>
<style>
/* 全局样式重置 */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html,
body {
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100vh;
}

/* 头部样式 */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: var(--color-surface);
    border-bottom: 1px solid var(--color-border);
    margin-top: 0;
    height: 100px;
}
.header-banner { background-position: center; background-repeat: no-repeat; background-size: contain; }

.header>p {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
}

.right_title {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.right_title p {
    margin: 2px 0;
    font-size: 14px;
    color: var(--color-text-secondary);
}

/* 主内容样式 */
.main_content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 20px;
    min-height: calc(100vh - 200px);
}

/* 注册容器样式 */
.register_container {
    background-color: var(--color-surface);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    padding: var(--space-4);
    width: 100%;
    max-width: 400px;
}

.register_container h1 {
    text-align: center;
    margin-bottom: 20px;
    color: var(--color-text-primary);
    font-size: 20px;
}

/* 表单样式 */
.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    color: var(--color-text-primary);
    font-size: 14px;
}

.form-group input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    font-size: 14px;
    transition: border-color 0.3s;
}

.form-group input:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.2);
}

/* 协议样式 */
.agreement {
    display: flex;
    align-items: flex-start;
    margin-bottom: 18px;
}

.agreement input[type="checkbox"] {
    width: auto;
    margin-right: 8px;
    margin-top: 2px;
    transform: scale(0.9);
}

.agreement label {
    flex: 1;
    font-size: 13px;
    color: var(--color-text-secondary);
    margin-bottom: 0;
}

.agreement a {
    color: var(--color-primary);
    text-decoration: none;
}

.agreement a:hover {
    text-decoration: underline;
}

/* 按钮样式 */
.register-btn {
    width: 100%;
    padding: 10px;
    background-color: var(--color-primary);
    color: white;
    border: 1px solid var(--color-primary);
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s;
}

.register-btn:hover { background-color: #0052a3; }

/* 登录链接样式 */
.login-link {
    text-align: center;
    margin-top: 20px;
}

.login-link p {
    font-size: 14px;
    color: var(--color-text-secondary);
}

.login-link a {
    color: var(--color-primary);
    text-decoration: none;
    font-weight: 500;
}

.login-link a:hover {
    text-decoration: underline;
}

/* 页脚样式 */
.footer {
    text-align: center;
    height: 50px;
    line-height: 50px;
    background-color: var(--color-surface);
    color: var(--color-text-secondary);
    font-size: 14px;
}
</style>
